import React, { useState } from 'react';
import { Avatar, Button, Card, Divider, Layout, Menu, Typography } from 'antd';
import {
  RobotOutlined,
  SettingOutlined,
  // UserOutlined,
} from '@ant-design/icons';
import EnjoLogo from '../icons/enjologo.svg';
import User from '../icons/user.svg';
import { useIsMobile } from '../hooks/screen-size';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedBot } from '../store/bot-slice';

const { Sider } = Layout;
const { Text } = Typography;
function ShowcaseSidebar({ updateSidebar }) {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile ? (
        <div
          style={{
            backgroundColor: '#F6F8FA',
            height: '100%',
            width: '100%',
          }}
        >
          <SidebarContent updateSidebar={updateSidebar} />
        </div>
      ) : (
        <Sider
          width={'18%'}
          style={{
            height: '100vh',
            backgroundColor: '#F6F8FA',
          }}
        >
          <SidebarContent />
        </Sider>
      )}
    </>
  );
}

export default ShowcaseSidebar;

const LoginCard = () => {
  return (
    <Card
      style={{
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        margin: '12px',
      }}
      styles={{ body: { padding: '0px' } }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          height: '100%',
          margin: '12px',
        }}
      >
        <Avatar size={40} src={User} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: '16px',
            gap: '6px',
          }}
        >
          <Text style={{ fontSize: 13, fontWeight: 700 }}>Login to Enjo</Text>
          <Text style={{ fontSize: 11 }} type="secondary">
            Unlock full Enjo access
          </Text>
        </div>
      </div>
      <Button
        type="primary"
        style={{
          width: '100%',
          borderRadius: '8px',
          backgroundColor: '#4D2AA4',
          borderColor: '#4D2AA4',
          fontWeight: 600,
          height: '40px',
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px',
        }}
        onClick={() => (window.location.href = 'https://app.enjo.ai/login')}
      >
        Signup for free
      </Button>
    </Card>
  );
};

const SidebarContent = ({ updateSidebar }) => {
  const { bots, selectedBot: initialBot } = useSelector((state) => state?.bots);
  const dispatch = useDispatch();
  const [selectedBot, setSelectedBot] = useState(
    initialBot?.botId || 'it_support'
  );
  const isMobile = useIsMobile();
  const getSideMenu = () => {
    if (bots?.length > 0) {
      const botArray = bots?.map((item) => {
        return {
          key: item?.botId,
          label: item?.botName,
          icon: <RobotOutlined />,
        };
      });
      botArray.push({
        key: 'contact_us',
        label: 'Contact us',
        icon: <SettingOutlined />,
      });
      return botArray;
    }
    return [
      {
        key: 'it_support',
        label: 'IT Support',
        icon: <RobotOutlined />,
      },
      // {
      //   key: 'hr_support',
      //   label: 'HR Support',
      //   icon: <RobotOutlined />,
      // },
      // {
      //   key: 'cs_support',
      //   label: 'CS Support',
      //   icon: <RobotOutlined />,
      // },
      {
        key: 'contact_us',
        label: 'Contact us',
        icon: <SettingOutlined />,
      },
    ];
  };
  const onMenuItemClick = (e) => {
    if (e.key === 'contact_us') {
      return (window.location.href = 'https://www.enjo.ai/demo');
    }
    const foundBot = bots?.find((bot) => bot?.botId === e.key);
    dispatch(
      updateSelectedBot({
        selectedBot: foundBot,
      })
    );
    if (updateSidebar) {
      updateSidebar(false);
    }
    setSelectedBot(e.key);
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <div>
        <div
          id="enjo__landing__navbar"
          style={{
            width: isMobile ? '' : '100%',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '30px',
            alignItems: 'center',
          }}
        >
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => (window.location.href = 'https://enjo.ai')}
          >
            <img src={EnjoLogo} alt="Enjo Logo" width={'100px'} />
          </div>
        </div>

        <Divider style={{ margin: 0 }} />

        <div
          style={{
            margin: '30px',
            display: 'flex',
            gap: '30px',
            flexDirection: 'column',
          }}
        >
          <Text strong style={{ color: '#64778E' }}>
            AI Agents
          </Text>
        </div>

        <Menu
          style={{
            backgroundColor: '#F6F8FA',
            border: 'none',
            margin: '0px 5px',
          }}
          selectedKeys={[selectedBot]}
          items={getSideMenu()}
          onClick={onMenuItemClick}
        />
      </div>

      <div>
        <LoginCard />
      </div>
    </div>
  );
};
